import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/sonoran/Navbar";
import Hero from "./components/sonoran/Hero";
import Marquee from "./components/sonoran/Marquee";
import Services from "./components/sonoran/Services";
import BeforeAfter from "./components/sonoran/BeforeAfter";
import Process from "./components/sonoran/Process";
import QuoteForm from "./components/sonoran/QuoteForm";
import Testimonials from "./components/sonoran/Testimonials";
import FinalCTA from "./components/sonoran/FinalCTA";
import Footer from "./components/sonoran/Footer";
import LiveActivity from "./components/sonoran/LiveActivity";
import { Toaster } from "./components/ui/sonner";

function Home() {
  useEffect(() => {
    // Reveal-on-scroll
    const els = document.querySelectorAll(".reveal");
    if (!("IntersectionObserver" in window)) {
      els.forEach((e) => e.classList.add("in"));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return (
    <div data-testid="home-page" className="bg-[#09090B] text-white">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <BeforeAfter />
        <Process />
        <QuoteForm />
        <Testimonials />
        <FinalCTA />
      </main>
      <Footer />
      <LiveActivity />
      <Toaster />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
